<template>
  <v-dialog fullscreen persistent scrollable>
    <template v-slot:activator="{ props }">
      <v-chip class="mr-1" v-bind="props" size="small" density="compact" style="font-size: 10px">
        <v-icon :icon="['fas', 'bug']" />
      </v-chip>
    </template>

    <template v-slot:default="{ isActive }">
      <v-card>
        <template v-slot:title>
          СООБЩИТЬ ОБ ОШИБКЕ?
        </template>
        <template v-slot:subtitle>
          Данный инструмент поможет сообщить об ошибке, найденной в инструменте
        </template>
        <template v-slot:text>
          <MessageBugReport />
        </template>
        <template v-slot:append>
          <v-btn
              rounded="xl"
              variant="tonal"
              color="deep-orange"
              text="ОТМЕНА"
              @click="isActive.value = false"
          />
        </template>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import MessageBugReport from "@/components/Global/message.bugreport.vue";

export default {
  name: "BugReport",
  components: {MessageBugReport},
  data() {
    return {

    }
  },
  computed: {

  }
}

</script>

<style scoped>

</style>
